import React from 'react';
import * as Icon from 'react-bootstrap-icons';

import { useNavigation } from '../../../common/navigation';

export const KwzLink: React.FC<{ kwzId: string }> = props => {
  const nav = useNavigation();

  return (
    <span
      className="link-primary"
      role="button"
      tabIndex={0}
      onClick={() => nav.sampleExam(props.kwzId)}
      onKeyDown={e => {
        if (e.key === 'Enter') {
          nav.sampleExam(props.kwzId);
        }
      }}
    >
      <Icon.BoxArrowRight />
    </span>
  );
};
